import React from 'react'
import styles from './Style.module.css'
import {BtnSecondary} from '../Buttons/BtnSecondary'
import { ImageWithFallback } from '../ImageWithFallback/ImageWithFallback'
import { formatTimeToAMPM } from '../../Utils/Helper'
import OutletCTA from '../OutletCTA/OutletCTA'

// Temporarily hide 24-hour labels; show supplied opening/closing times instead.
const SHOW_24_HOUR_LABELS = false; // Set to false to hide 24-hour labels and show opening/closing times instead.

export const OutletCard = ({
    hideTiming = false,
    contactToOutlet,
    image, 
    name, 
    address, 
    timing,
    isOpen24 = false,
    webComingSoon = false,
    announcements = [],
    contactNumber,
    whatsappNumber,
    selected, 
    handleSelect,
    hideContact = false,
    hideSelectBtn = false,
    hideAnnouncements = false,
}) => {

  const timings = Array.isArray(timing) ? timing : timing ? [timing] : [];
  const isComingSoon = webComingSoon === true;
  const showSelectedTag = selected && !isComingSoon && !hideSelectBtn && !contactToOutlet;
  const showSelectButton = !hideSelectBtn && !contactToOutlet && !showSelectedTag;
  const hasTimingHours = (time) => (SHOW_24_HOUR_LABELS && Number(time?.['24_hr']) === 1) || Boolean(time?.open && time?.close);
  const visibleTimings = timings.filter(hasTimingHours);
  const isOpenAllDay = SHOW_24_HOUR_LABELS && isOpen24 === true;
  const timingContent = isComingSoon || (!isOpenAllDay && visibleTimings.length === 0) ? null : (
    <div>
      {isOpenAllDay ? <p>Open 24 hrs</p> : visibleTimings.map((time, i) => (
        <p key={i}>
          {SHOW_24_HOUR_LABELS && Number(time?.['24_hr']) === 1 ? 'Open 24 hrs' : (
            <>
              {formatTimeToAMPM(time?.open)}
              <span> - </span>
              {formatTimeToAMPM(time?.close)}
            </>
          )}
        </p>
      ))}
    </div>
  );


  return (
    <div className={styles.OutletCardContainer}>
    <div className={`${styles.OutletCard} card-shine ${isComingSoon ? styles.comingSoon : ''}`}>
        <figure className={`${styles.left} shine`}>
            <ImageWithFallback
              src={image}
              className='object-cover'
              alt=''
            />
        </figure>
        <div className={styles.right}>
            <div className={styles.rightCard}>
                <div className={`${styles.detail} ${!showSelectButton ? styles.detailWithoutSelectBtn : ""}`}>
                    <div className={styles.nameRow}>
                        <h2>{name}</h2>
                        {showSelectedTag && <span className={styles.selectedTag}>Selected</span>}
                    </div>
                    <p>{address}</p>
                    {!hideTiming && timingContent}
                </div>
                {hideSelectBtn || contactToOutlet ? "" : (
                <div className={styles.ocSelect}>
                {isComingSoon ? (
                  <span className={styles.comingSoonBadge}>Coming Soon</span>
                ) : (
                <BtnSecondary
                label="Select"
                handleClick={handleSelect}
                />
                )}
                </div>
                )}
            </div>
        </div>
    </div>
    {!hideAnnouncements && announcements.length > 0 && (
      <>
      {announcements.map(announcement => (
        <div key={announcement.id} className={styles.announcement}>
          <p>Note: {announcement.title}</p>
        </div>
      ))}
      </>
    )}
    {!hideContact && contactToOutlet && (
      <OutletCTA 
      whatsappNumber={whatsappNumber} 
      contactNumber={contactNumber} 
      customClass={styles.contactOutlet}
      />
    )}
    </div>
  )
}
